export default __webpack_public_path__ + "static/media/lock-normal.436334cb.png";